import React, { useEffect, useState } from 'react'
import { Modal, Button } from 'antd'
import { ModalStyled } from './commonStyled'

const { Title, Description, Footer } = ModalStyled

export default function SessionWarningModal({ visible, onStayLoggedIn, onLogoutNow, countdownSeconds = 300 }) {
  const [secondsLeft, setSecondsLeft] = useState(countdownSeconds)

  useEffect(() => {
    if (visible) {
      setSecondsLeft(countdownSeconds)
    }
  }, [visible, countdownSeconds])

  useEffect(() => {
    let interval = null
    if (visible && secondsLeft > 0) {
      interval = setInterval(() => {
        setSecondsLeft(secondsLeft => secondsLeft - 1)
      }, 1000)
    } else if (secondsLeft === 0) {
      // Auto-logout when countdown reaches zero
      onLogoutNow()
    }
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [visible, secondsLeft, onLogoutNow])

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60)
    const remainingSeconds = seconds % 60
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`
  }

  return (
    <Modal
      open={visible}
      footer={null}
      bodyStyle={{ paddingBottom: 0 }}
      zIndex={1000}
      width={500}
      closable={false}
      maskClosable={false}
    >
      <Title>Session Warning</Title>
      <Description>
        Your session will expire in <strong>{formatTime(secondsLeft)}</strong> due to inactivity. 
        Would you like to stay logged in?
      </Description>
      <Footer>
        <Button
          onClick={onStayLoggedIn}
          type="primary"
          style={{ marginRight: 8 }}
        >
          Stay Logged In
        </Button>
        <Button onClick={onLogoutNow}>
          Log Out Now
        </Button>
      </Footer>
    </Modal>
  )
}
